window.Cookies = require('js-cookie');
